import React from "react";
import {
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
  Icon,
  Box,
  PopoverArrow
} from "@chakra-ui/react";
import { IconType } from "react-icons/lib";
import { Callback } from "utils/types";

interface Props {
  icon: IconType;
  deviceList: MediaDeviceInfo[];
  callback: Callback;
}

const DeviceSelector: React.FC<Props> = ({
  icon,
  deviceList,
  callback
}: Props) => (
  <Popover placement="bottom-end">
    {({ onClose }) => (
      <>
        <PopoverTrigger>
          <a>
            <Icon as={icon} />
          </a>
        </PopoverTrigger>
        <PopoverContent>
          <PopoverArrow />
          <PopoverBody>
            {deviceList.map((device, index) => (
              <Box
                _hover={{
                  cursor: "pointer",
                  bg: "gray.600"
                }}
                key={`audio_input_${index}`}
                onClick={() => {
                  onClose();
                  callback(device.deviceId);
                }}
              >
                {device.label}
              </Box>
            ))}
          </PopoverBody>
        </PopoverContent>
      </>
    )}
  </Popover>
);

export default DeviceSelector;
